var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCctvIconDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_14611",
    "data-name": "\\uADF8\\uB8F9 14611",
    transform: "translate(-1197 -560)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_8445",
    "data-name": "\\uC0AC\\uAC01\\uD615 8445",
    transform: "translate(1197 560)",
    fill: "#ccc",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_520_",
    transform: "translate(1195.65 563.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_521_",
    d: "M5.173,8.668,6.347,10.7a.587.587,0,0,0,.7.263l1.727-.584a4.688,4.688,0,0,0,.474.274L9.6,12.44a.587.587,0,0,0,.576.472h2.348a.587.587,0,0,0,.576-.472l.357-1.787a4.7,4.7,0,0,0,.474-.274l1.727.584a.587.587,0,0,0,.7-.263l1.174-2.033a.587.587,0,0,0-.121-.734l-1.37-1.2c.005-.091.008-.182.008-.273s0-.182-.008-.273l1.37-1.2a.587.587,0,0,0,.121-.734L16.355,2.211a.587.587,0,0,0-.7-.263l-1.727.584a4.683,4.683,0,0,0-.474-.274L13.1.472A.587.587,0,0,0,12.525,0H10.178A.587.587,0,0,0,9.6.472L9.245,2.259a4.7,4.7,0,0,0-.474.274L7.043,1.949a.587.587,0,0,0-.7.263L5.173,4.245a.587.587,0,0,0,.121.734l1.37,1.2c-.005.091-.008.182-.008.273s0,.182.008.273l-1.37,1.2A.587.587,0,0,0,5.173,8.668Zm6.178-4.559A2.348,2.348,0,1,1,9,6.456,2.35,2.35,0,0,1,11.351,4.108Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctvIconDefault);
export default __webpack_public_path__ + "static/media/cctvIcon_default.583b75296b562f282f00c08ea4bc4233.svg";
export { ForwardRef as ReactComponent };